
require([ 'hyprlivescc' ], function ( Hypr ) {window.scc.Hypr=Hypr}); 
define("modules/scc-hypr", function(){});
